/* Built In Imports */
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

/* External Imports */
import { AspectRatio, Box, Flex, Image, Link, Text } from '@chakra-ui/react';
import ReactPlayer from 'react-player';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import BenefitsSection from '@components/UI/YantraCeremony/BenefitsSection';
import InterestedForm from '@components/UI/YantraCeremony/IntrestedForm';
import ParticipantExp from '@components/UI/YantraCeremony/ParticipantExp';
import SadhanaModule from '@components/UI/YantraCeremony/SadhanaModule';
import YantraContactUs from '@components/UI/YantraCeremony/YantraContactUs';
import YantraHeader from '@components/UI/YantraCeremony/YantraHeader';
import YantraSection from '@components/UI/YantraCeremony/YantraSection';
import YantraSocialMedia from '@components/UI/YantraCeremony/YantraSocialMedia';
import YantraTableModule from '@components/UI/YantraCeremony/YantraTableModule';
import HeadComponent from '@components/Utility/HeadComponent';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  filterBuildUrls,
  getLatestBuild,
} from 'services/commonService';
import { fetchYantraPageData } from 'services/landingPageService';
/* Mixpanel for SEO*/
import { mixPanel } from '@utils/Mixpanel';

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - YantraCeremony Landing Page Data
 * @returns
 */
export default function YantraCeremony({ pageData, region, language }) {
  const [show, setShow] = React.useState(false);
  const handleToggle = () => setShow(!show);
  const [isLoader, setIsLoader] = useState(false);
  const router = useRouter();

  // Mixpanel
  function iaminterested() {
    MixpanelTrigger('iso_lead_interested_cta_clicked');
    //Form load
    if (router.asPath.indexOf('#program-fee')) {
      MixpanelTrigger('iso_lead_form_impression');
    }
  }

  function MixpanelTrigger(eventkey) {
    const Mixpanel = mixPanel(router.asPath);
    Mixpanel.track(eventkey, {
      page_name: document.title,
      program_name: 'Yantra_Ceremony',
    });
  }

  useEffect(async () => {
    if (document != undefined) {
      const script = document.createElement('script');
      script.src = `${config.YANTRAINLINEFORM}`;
      script.async = true;
      document.body.appendChild(script);
      setIsLoader(true);
    }
    setTimeout(function () {
      setIsLoader(false);
    }, 5000);
    return () => {};
  }, []);

  const renderUIContent = () => {
    return pageData?.body.map((section, i) => {
      switch (section.sectionId) {
        case uiSection.YANTRAHEADER:
          return <YantraHeader headerData={section.sectionContent} key={i} />;
        case uiSection.SECTION2:
          return <YantraSection sectionData={section.sectionContent} key={i} />;
        case uiSection.SECTION3:
          return (
            <Box bgColor="#500104" key={i} position="relative">
              <Box
                maxWidth="768px"
                mx="auto"
                textAlign="center"
                px={{ base: '20px', md: '0' }}
                fontFamily="FedraSansStd-book"
              >
                <Image
                  src={`${config.imgPath}/d/46272/1656741032-divider_yellow.png`}
                  mb={{ base: '30px', md: '70px' }}
                  alt="divider"
                  title="Divider"
                  mt={{ base: '30px', md: '0' }}
                />
                <Text
                  color="#fff"
                  mb="30px"
                  fontSize="16px"
                  className="yantra-structure"
                  textAlign="left"
                >
                  {StructuredTextContent(section.sectionContent[0].body)}
                </Text>
              </Box>
              <Box
                clipPath="polygon(0 0, 100% 0, 100% 60%, 0% 100%)"
                bgColor="#500004"
                borderColor="#FFF7E2"
                width="100%"
                height="150px"
                position="relative"
                bottom={{ base: '13px', md: '-34px' }}
                margin="-2px auto 0"
              ></Box>
              <Box bgColor="#FFF7E2" pb="50px" px="20px" marginTop="-115px">
                <Box maxWidth="768px" mx="auto" position="relative" bgColor="">
                  <AspectRatio
                    borderRadius="20px"
                    overflow="hidden"
                    width="100%"
                    ratio={2}
                    height={{ base: '180px', md: '413px' }}
                    boxShadow="0px 20px 20px rgba(0, 0, 0, 0.4)"
                    minH={{ base: '180px', md: '413px' }}
                  >
                    <ReactPlayer
                      url={section.sectionContent[1].embedUrl}
                      light={true}
                      playing
                      controls
                      width="100%"
                      height="100%"
                    />
                  </AspectRatio>
                  <Box
                    display={{ base: 'block', md: 'flex' }}
                    alignItems="center"
                    justifyContent="center"
                    my="40px"
                    textAlign={{ base: 'center', md: 'left' }}
                    onClick={() => {
                      window.dataLayer.push({
                        event: 'Interested_Users',
                        program_name: 'Yantra_Ceremony',
                        Button_Location: '<Below_Video_CTA>',
                      });
                    }}
                  >
                    <Link
                      onClick={() => iaminterested()}
                      bgColor="#FFCB12"
                      color="#28231E"
                      href={refineUrlDomain(
                        section.sectionContent[2].linkUrl,
                        region,
                        language
                      )}
                      mr={{ base: '0', md: '20px' }}
                      padding="10px 30px"
                      borderRadius="5px"
                      display="inline-block"
                      mb="20px"
                      fontFamily="FedraSansStd-medium"
                      _hover={{
                        bgColor: '#FFCB12',
                        textDecoration: 'none',
                      }}
                      _focus={{
                        bgColor: '#FFCB12',
                        textDecoration: 'none',
                      }}
                      _active={{
                        bgColor: '#FFCB12',
                        textDecoration: 'none',
                      }}
                    >
                      {section.sectionContent[2].buttonText}
                    </Link>
                    <Box className="yantra-structure v2" color="#000">
                      {StructuredTextContent(section.sectionContent[3].body)}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          );
        case uiSection.BENEFITSSECTION:
          return (
            <BenefitsSection benefitsData={section.sectionContent[0]} key={i} />
          );
        case uiSection.SADHANAMODULES:
          return <SadhanaModule moduleData={section.sectionContent} key={i} />;

        case uiSection.TABLEMODULE:
          return (
            <YantraTableModule
              tableData={section.sectionContent}
              key={i}
              sectionid={section?.sectionId}
            />
          );
        case uiSection.INLINEFORM:
          return (
            <InterestedForm
              formData={section.sectionContent}
              key={i}
              sectionid={section?.sectionId}
            />
          );
        case uiSection.PARTICIPANTEXP:
          return (
            <ParticipantExp participantData={section.sectionContent} key={i} />
          );
        case uiSection.CONTACTUS:
          return (
            <Box
              marginTop={{ base: '0', md: '0' }}
              position="relative"
              zIndex="1"
            >
              <Box bgColor="#fff7e1">
                <Box
                  clipPath="polygon(100% 40%, 0% 100%, 100% 100%)"
                  bgColor="#500004"
                  borderColor="#FFF7E2"
                  width="100%"
                  height="100px"
                ></Box>
              </Box>
              <Box
                bgGradient="linear(180deg, #500004 35.11%, #500004 94.61%)"
                padding={{ base: '30px 0', md: '0px 0 50px' }}
                mt="-1px"
              >
                <Box
                  maxWidth={{ base: '100%', md: '998px', lg: '1120px' }}
                  fontFamily="FedraSansStd-A-medium"
                  mx="auto"
                  padding={{
                    base: '0px 20px',
                    md: '10px 40px 15px',
                  }}
                >
                  <Flex flexDir={{ base: 'column', md: 'row' }} w="100%">
                    <YantraSocialMedia
                      pageData={pageData}
                      secData={uiSection.STAYTUNE}
                    />
                    <YantraContactUs
                      pageData={pageData}
                      secData={uiSection.CONTACTUS}
                    />
                  </Flex>
                </Box>
              </Box>
              <style jsx global>
                {`
                  .footerlink a {
                    color: #ffffff !important;
                    text-decoration: underline;
                  }
                `}
              </style>
            </Box>
          );

        default:
          break;
      }
    });
  };

  const uiSection = {
    YANTRAHEADER: 'Header',
    SECTION2: 'Section-2',
    SECTION3: 'Section-3',
    BENEFITSSECTION: 'Section-4',
    SADHANAMODULES: 'Section-5',
    TABLEMODULE: 'program-fee',
    INLINEFORM: 'interested-in-the-program',
    PARTICIPANTEXP: 'Section-7',
    STAYTUNE: 'stay-tuned',
    CONTACTUS: 'contact-us',
  };

  return (
    <>
      <HeadComponent
        data={pageData._seoMetaTags}
        availableLocals={pageData.availableLocales}
      ></HeadComponent>

      {renderUIContent()}
      <style global jsx>{`
        .yantra-structure p {
          margin-bottom: 20px;
          line-height: 26px;
        }
        .yantra-structure.v2 a {
          color: #500104;
          text-decoration: underline;
          font-family: 'FedraSansStd-medium';
        }
        .yantra-structure.m-0 p {
          margin: 0;
        }
        .yantra-structure h3 {
          font-size: 28px;
          font-family: 'FedraSansStd-medium';
          color: '#fff';
        }
        .yantra-structure a {
          color: #ffcb12;
        }
        .yantra-structure mark {
          background-color: transparent;
          color: #ffcb12;
        }
        .react-player__shadow {
          width: 84px !important;
          height: 84px !important;
          background: #ffcb12 !important;
        }
        .react-player__play-icon {
          border-color: transparent transparent transparent #0c0c0c !important;
          border-width: 12px 0px 12px 22px !important;
        }
      `}</style>
    </>
  );
}

export const getStaticPaths = async () => {
  let yantraCeremonyPath = config.USE_LOCAL_URL
    ? [
        '/in/en/events/special-events/yantra-ceremony-with-sadhguru',
        '/us/en/events/special-events/yantra-ceremony-with-sadhguru',
      ]
    : [];
  if (process.env?.NEXT_PUBLIC_BUILD_ID) {
    let data = await getLatestBuild(process.env.NEXT_PUBLIC_BUILD_ID);
    yantraCeremonyPath = filterBuildUrls(
      'landing_pages',
      'L2',
      '/events/special-events/yantra-ceremony-with-sadhguru',
      '/events/special-events/yantra-ceremony-with-sadhguru-',
      data
    );
  } else if (config.BUILD_URLS?.LANDING_PAGES?.YantraCeremony) {
    let pageData = await fetchYantraPageData();
    yantraCeremonyPath = pageData?.availableLocales
      ? pageData?.availableLocales.map(locale => {
          return encodeURI(locale.value);
        })
      : [];
  }
  // consoleLog('11111111111yantraCeremonyPath', yantraCeremonyPath);
  return {
    paths: yantraCeremonyPath,
    fallback: false,
  };
};

export const getStaticProps = async ({ params: { region, language }, req }) => {
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchYantraPageData(region, language);
  return {
    props: {
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
    },
  };
};
